import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { parseDocumentVersionRef } from "../../../shared/references/contentReferences";
import { appPaths } from "../../../shared/routing/appPaths";
import { useDocumentName } from "./useSourceDocument";

/**
 * A document version as people read it (`useDocumentName`), linking to that exact version.
 * Until the name is read, or if it cannot be, "Document" stands in;
 * the full reference is the link's tooltip.
 */
export default function DocumentVersionName({ reference }: { reference: string }) {
  const { t } = useTranslation();
  const version = parseDocumentVersionRef(reference);
  const name = useDocumentName(version) ?? t("sources.document.unnamed");
  if (version === null) {
    return <span title={reference}>{name}</span>;
  }
  return (
    <Link to={appPaths.sourceDocument(version)} title={reference} className="app-link underline">
      {name}
    </Link>
  );
}
